module.exports = __webpack_public_path__ + "static/media/lock-alt.02445b0d.svg";